export default __webpack_public_path__ + "static/media/jackfruit.4e9a116d.png";